const removeUnnecessaryElements = () => {
  if (typeof document === 'undefined') {
    return
  }
  // eslint-disable-next-line @typescript-eslint/no-extra-semi
  ;[...document.querySelectorAll('[data-remove-on-prerender]')].forEach(
    (elem) => {
      elem.remove()
    },
  )
}

export default removeUnnecessaryElements
